import { render, staticRenderFns } from "./WelcomeDialog.vue?vue&type=template&id=c0b06fc0&scoped=true&lang=pug"
import script from "./WelcomeDialog.vue?vue&type=script&lang=js"
export * from "./WelcomeDialog.vue?vue&type=script&lang=js"
import style0 from "./WelcomeDialog.vue?vue&type=style&index=0&id=c0b06fc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b06fc0",
  null
  
)

export default component.exports